import { PeopleDepartmentDto } from "./people-department.dto";
import { PeopleMerchantGroupDto } from "./people-merchant-group.dto";
import { PeopleEmployeeWorkProfileDto } from "./employee/people-employee-work-profile.dto";
import { PeopleQueryBaseDto } from "./people-query-base.dto";

export class PeopleJobTitleDto {
    id?: number;
    name?: string;
    code?: string;
    merchantGroupId?: number;
    departmentId?: number;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    department?: PeopleDepartmentDto;
    merchantGroup?: PeopleMerchantGroupDto;
    employeeWorkProfiles?: PeopleEmployeeWorkProfileDto[];
}

export interface PeopleJobTitleQueryDto extends PeopleQueryBaseDto {
    name?: string;
    departmentId?: number;
    merchantGroupId?: number;
    join?: string | string[];
}